import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { Dialog } from '@mui/material';
import BaseButton from '../../../../components/BaseButton';

export const ExistDecisionDialog = (props) => {

    const {open, setOpen, handleCancel} = props

    return (
        <Dialog
            open={open}
            onClose={()=> setOpen(false)}
        >
            <div className="dialog__row-container" style={{justifyContent: 'space-between'}}>
                <div style={{width: '31px'}}></div>
                <h2>Atenção!</h2>
                <IconButton
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon />
                </IconButton>
            </div>
            <div className="dialog__column-container">
                <h3>Tem certeza que deseja cancelar este processo?</h3>
                <p style={{marginTop: '5px', marginBottom: '5px'}}>Toda informação preenchida aneteriormente será perdida.</p>
                <BaseButton
                    label="CONFIRMAR"
                    className="btn__container--center btn btn--red btn--animated"
                    onClick={() => handleCancel()}
                />
            </div>
        </Dialog>
    );
}